<template>
  <article class="">
    <cabeceraEN></cabeceraEN>
         <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Corporate Governance</h2>
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="caja">
          <h5>Corporate Governance</h5>
          <p>At MEGA we promote and encourage the adoption of best practices in corporate governance.
            Welcome believe these practices are powerful tools to build economic security and legal certainty
            for investors, the community, the Company and all Company shareholders and employees, adding transparency and integrity to our governance practices.
          <br><br>
            At present, MEGA’s Corporate Governance practices are governed by the Company’s
            Bylaws, Code of Ethics, Internal Policies, Corporations Law No. 19.550, Capital Market Law No. 26.831, CNV standards and other effective statutes and regulations.

            </p>
            <!-- <h5 style="margin-top: 20px">Code of Ethics</h5>
          <p>
          The purpose of our Code of Ethics is to provide all Company members with a set of guiding
          principles for professional behavior during day-to-day operations and in all business,
          operating, and professional relationships. Our Code of Ethics applies to the Board of
          Directors, the Statutory Auditing Committee, and all Company managers, employees, suppliers, contractors, subcontractors, and business partners.<br><br>

          <a target="_blank" href="static/pdf/codigo-de-etica-compania-mega.pdf">Download Code of Ethics<i class="icon-file-pdf"></i></a>
          </p> -->
            
        </div>
      </div>
      
    </section>
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <p>MEGA S.A.&#39;s Ethics Line is a tool designed to report Code of Ethics violations. This line is available 24/7 and is managed by a third-party firm, BDO, to guarantee confidentiality, anonymity, transparency.</p>        
            <img src="./linea-etica.jpg" alt="Banner de las plantas de Mega Cia." class="img-fluid">
          </div>
        </div>
      </div>
    </section>
    <section class="secundario">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8">
            <h4>Whistleblower Channels</h4>
            <ul>
              <li>Telephone: 0800-34-LINEA (54632)</li>
              <li>Webpage: <a href="http://www.bdolineaetica.com/ciamega" target="_blank">www.bdolineaetica.com/ciamega</a></li>
              <li>Email: <a href="mailto:ciamega@bdolineaetica.com">ciamega@bdolineaetica.com</a></li>
              <li>Mailing Address: Rondeau 2664 PB, C1262ABH CABA</li>
              <li>Personal Interviews: Maipú 942 PB, C1006ACN CABA</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="descargas">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-8"> 
            <a href="static/pdf/manual-del-anuciante-mega.pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DOWNLOAD MANUAL</span></a>
            <a href="static/pdf/Mega_ManualDeEtica_Mayo2021 (1).pdf" target="_blank"><img src="./icon-pdf.jpg" alt=""><span>DOWNLOAD CODE OF ETHICS</span></a>
          </div>
        </div>
      </div>
    </section>   
    <pieEN></pieEN>
  </article>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
h5
  font-size: 30px
.btn-ar
    display: flex
    justify-content: center
    border: solid 1px #444
    margin-top: 30px
    width: 300px
    padding: 5px
    border-radius: 0px
    // &:hover
    // background-color: #004D9E
    &:hover
      background-color: #004D9E
      border-color: #fff
      a h5
        color: #fff
a h5
  font-size: 18px
  margin: 0
  display: inline-block
  color: black
  &:hover
    color: #fff
p
  padding-top: 15px
  padding-left: 10px
  padding-right: 10px
  text-align: center
  a
    color: #004D9E
i
  font-size: 16px
  opacity: 0.8
.caja
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  h5
  padding-top: 30px
  /* Global Styles */
.descripcion 
  margin: 0
  padding: 0
  p 
    margin: 40px 0
.secundario
  margin: 0
  padding: 0
  h4 
    margin: 40px 0 30px
    font-size: 20px
    font-weight: 500
  ul 
    padding-left: 20px
    margin: 0
    li 
      list-style: circle
      a
        color: #004d9e
.descargas
  padding: 40px 0
  a
    padding-right: 30px
    display: inline-block
    vertical-align: top
    color: #004d9e
    font-weight: 500
    font-size: 14px
    @media(max-width: 550px)
      display: block
      padding: 0
    img,
    span
      display: inline-block
      vertical-align: middle
    img 
      padding-right: 10px
  /* Global Styles */

</style>

<script>
export default {
  name: 'gobierno',
  components: {
    CabeceraEN,
    PieEN
  }
}
import $ from 'jquery'
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
$(document).ready(function () {
  $('.btn').click(function () {
    $(this).toggleClass('active')
    $('.profile .box').toggleClass('open')
  })
})
</script>





// WEBPACK FOOTER //
// src/components/gobierno-en/gobierno-en.vue